import React, {PropsWithChildren, useEffect, useState} from "react";
import {observer} from "mobx-react";
import {
    IPopupDialogRenderer,
} from "../../services/dialog/dialog.service.interface";
import ReactModal, {Styles as ReactModalStyles} from "react-modal";
import {getCommonModalContentStyles, getCommonModalOverlayStyles} from "./common-modal-content-styles";
import {IServiceFactory} from "../../services/service-factory.interface";
import {useServices} from "../../hooks/use-services.hook";


interface PopUpDialogComponentProps extends PropsWithChildren {
    renderer: IPopupDialogRenderer;
    maxHeight?: string;
    height?: string;
    /**
     * true if the popup can be closed by clicking on the backdrop overlay
     */
    backdropDismiss?: boolean;
}

export const PopUpDialogComponent: React.FC<PopUpDialogComponentProps> = observer((props) => {
    const services = useServices();
    const [isAnimated, setIsAnimated] = useState(false);

    useEffect(() => {
        setIsAnimated(true);
    }, []);


    const captureElementRef = (element: any) => {
        props.renderer.attachElementRef(element)
    }

    /*
    const onDismissHandler = (event: any) => {
        if(event?.detail?.role === 'backdrop') {
            props.renderer.onBackdropDismiss();
        }
    }
*/

    const positioning = computePositioning(services);

    const styles: ReactModalStyles = {
        content: {
            ...getCommonModalContentStyles(),
            ...positioning,
            transition: 'top 0.2s ease-in-out',
            top: isAnimated ? positioning.top : '100%',
            borderRadius: services.theme.currentTheme.border.defaultRadius,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: services.theme.currentTheme.border.mainColor,
        },
        overlay: {
            ...getCommonModalOverlayStyles(services)
        }
    }

    return (
        <ReactModal key={props.renderer.id}
                    id={props.renderer.id}
                    //maxHeight={props.maxHeight}
                    //height={props.height}
                    isOpen={props.renderer.isOpen}
                    shouldCloseOnEsc={true}
                    //keyboardClose={false}
                    shouldCloseOnOverlayClick={props.backdropDismiss ?? false}
                    ref={captureElementRef}
                    style={styles}
                    //onAfterClose={onDismissHandler}
        >
            {props.children}
        </ReactModal>
    );
});


function computePositioning(services: IServiceFactory): React.CSSProperties {
    if(services.screenMediaQuery.sAndBelow) {
        return {
            top: '15%',
            bottom: '15%',
            left: services.theme.currentTheme.spacing.dialogHorizontalPadding,
            right: services.theme.currentTheme.spacing.dialogHorizontalPadding

        }
    }
    if(services.screenMediaQuery.mAndBelow) {
        return {
            top: '15%',
            bottom: '15%',
            right: '10%',
            left: '10%',
        }
    }

    if(services.screenMediaQuery.lAndBelow) {
        return {
            top: '15%',
            bottom: '15%',
            right: '15%',
            left: '15%',
        }
    }

    return {
        top: '20%',
        bottom: '20%',
        right: '25%',
        left: '25%',
    }

}